<template>
  <div id="app">
    <!-- <dv-full-screen-container> -->
      <router-view></router-view>
    <!-- </dv-full-screen-container> -->
    
  </div>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0px;
}
body{
  margin: 0px;
  padding: 0px;
  width: 100vw;
  height: 100vh;
}
</style>
